import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import {
  NzDatePickerComponent,
  NzDatePickerModule,
} from 'ng-zorro-antd/date-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { DataGridComponent } from '../../../Common/Components/data-grid/data-grid.component';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { ApiService } from '../../../Services/api.service';
import { AuthService } from '../../../Services/auth.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-content-linked',
  standalone: true,
  imports: [
    CommonModule,
    NzInputModule,
    ReactiveFormsModule,
    NzIconModule,
    NzAutocompleteModule,
    NzDatePickerModule,
    NzButtonModule,
    DataGridComponent,
    NzSelectModule,
    FormsModule,
    ConfirmPopupComponent,
  ],
  templateUrl: './content-linked.component.html',
  styleUrl: './content-linked.component.scss',
})
export class ContentLinkedComponent implements OnInit, OnChanges {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
  ) {}
  @Input() seqId: string = '';
  @Input() contentType: string = '';
  @ViewChild('endDatePicker', { static: false })
  endDatePicker!: NzDatePickerComponent;

  activeTab: string = '';
  edpArValue: any = [];
  dateRange: any;
  startDate: any;
  endDate: any;
  programList: any = [];
  workProgramList: any = [];
  programValue: string = '';
  workProgramValue: any = [];
  edp_ar_list: any = [];
  org_edp_ar_list: any = [];
  program_list: any = [];
  org_program_list: any = [];
  edpArNoList: any = [];
  searchKey: any = '';
  newEDPAssociations: any = [];
  selectedIds = new Set<number>();
  validateValues: boolean = false;
  showModal: boolean = false;
  DefaultExists: boolean = false;
  messageList: any = [
    'New EDP/AR Association added successfully',
    'EDP/AR Association updated successfully',
    'EDP/AR Association deleted successfully',
    'New Program Association added successfully',
    'Program Association updated successfully',
    'Program Association deleted successfully',
  ];
  linkedStatus = [
    {
      id: 1,
      name: 'Linked AR/EDP',
      clicked: false,
    },
    {
      id: 2,
      name: 'Linked Program',
      clicked: false,
    },
  ];
  edpColumns = [
    {
      field: 'cedpNo',
      header: '',
      type: 'checkbox',
    },
    {
      field: 'cedpNo',
      header: 'EDP/AR #',
      compare: (a: any, b: any) =>
        (a.cedpNo ?? '').localeCompare(b.cedpNo ?? ''),
    },
    {
      field: 'tvalidFrom',
      header: 'Start Date & Time',
      dateField: true,
      compare: (a: any, b: any) =>
        (a.tvalidFrom ?? '').localeCompare(b.tvalidFrom ?? ''),
    },
    {
      field: 'tvalidTo',
      header: 'End Date & Time',
      dateField: true,
      compare: (a: any, b: any) =>
        (a.tvalidTo ?? '').localeCompare(b.tvalidTo ?? ''),
    },
    {
      field: '',
      header: 'Action',
      icons: ['edit', 'delete'],
      type: 'icon',
      showIcons: true,
    },
  ];
  program_fields = [
    {
      field: 'uniquePrgId',
      header: '',
      type: 'checkbox',
    },
    {
      field: 'programCode',
      header: 'Program Code',
    },
    {
      field: 'workGroupName',
      header: 'WorkGroup Name',
    },
    {
      field: 'validFrom',
      header: 'Start Date & Time',
      dateField: true,
    },
    {
      field: 'validTo',
      header: 'End Date & Time',
      dateField: true,
    },
    {
      field: '',
      header: 'Action',
      icons: ['edit', 'delete'],
      type: 'icon',
      showIcons: true,
    },
  ];
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  searchText: string = '';
  isZeroSelected: boolean = false;
  isOthersSelected: boolean = false;

  ngOnInit(): void {
    this.setDefaultDateRange();
    this.handleTab(this.linkedStatus[0]);
  }

  disabledDate = (current: Date): boolean => {
    if (!this.startDate) {
      return false;
    }
    const start = new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate(),
    ).getTime();
    const currnt = new Date(
      current.getFullYear(),
      current.getMonth(),
      current.getDate(),
    ).getTime();
    return currnt < start;
  };

  disablePastDates = (current: Date): boolean => {
    // Disable dates before today
    return current < new Date(new Date().setHours(0, 0, 0, 0));
  };

  addDefaultToArrayList() {
    if (!this.DefaultExists && !this.edpArNoList.includes('DEFAULT')) {
      this.edpArNoList.unshift('DEFAULT');
    }
  }

  pushDefault() {
    if (!this.edpArValue.includes('DEFAULT'))
      this.edpArValue = [...this.edpArValue, 'DEFAULT'];
  }

  setDefaultDateRange() {
    const current = new Date(new Date().setHours(0, 0, 0, 0));
    this.startDate = current;
    this.endDate = new Date(
      current.getFullYear() + 10,
      current.getMonth(),
      current.getDate(),
    ).getTime();
  }

  ngOnChanges() {
    if (this.contentType != 'N' && this.contentType != 'W') {
      this.linkedStatus = [this.linkedStatus[0]];
    }
  }

  handleTab(tab: any) {
    this.searchText = '';
    this.linkedStatus.map((node) => {
      if (node.id == tab.id) {
        node.clicked = true;
        this.activeTab = node.name;
        if (node.id == 1) {
          if (this.seqId) this.getAdpErAssociation(this.seqId);
        } else if (node.id == 2) {
          this.getProgramList();
        }
      } else {
        node.clicked = false;
      }
    });
  }

  searchAdpErNo(edpArNo: string, seqId: string) {
    if (edpArNo.length == 5 || edpArNo.length == 11) {
      this.apiService.getEdpArNoList(edpArNo, seqId).subscribe((response) => {
        if (response.edpArNo) {
          this.edpArNoList = response.edpArNo;
          this.addDefaultToArrayList();
        }
      });
    }
  }

  deleteRow(data: any) {
    this.prepareDeleteData([data.cedpNo]);
  }

  updateRow(data: any) {
    if (this.activeTab == 'Linked AR/EDP') {
      if (data.tvalidTo < data.tvalidFrom) {
        this.apiService.createNotification(
          'error',
          'To Date Should be greater than From Date',
        );
        this.edp_ar_list = JSON.parse(JSON.stringify(this.org_edp_ar_list));
        return;
      } else {
        this.updateEDPData([data.cedpNo]);
      }
    } else {
      if (data.validTo < data.validFrom) {
        this.apiService.createNotification(
          'error',
          'To Date Should be greater than From Date',
        );
         this.program_list = JSON.parse(JSON.stringify(this.org_program_list));
        return;
      } else {
        this.updateProgramListData([data.uniquePrgId]);
      }
    }
  }

  deAssociate() {
    this.showModal = true;
  }

  onDeleteConfirm(): void {
    this.showModal = false;
    const deleteList = [...this.selectedIds];
    if (this.activeTab == 'Linked AR/EDP') {
      this.prepareDeleteData(deleteList);
    } else {
      this.prepareProgramListDeleteData(deleteList);
    }
  }

  onDeleteCancel(): void {
    this.showModal = false;
  }

  prepareDeleteData(deleteList: any) {
    let deleteEDPAssociationList: any = [];
    this.edp_ar_list.forEach((element: any) => {
      if (deleteList.indexOf(element.cedpNo) !== -1) {
        let formatData = {
          seqNo: this.seqId,
          siteId: 204,
          edpNo:
            element.cedpNo == 'Default Site Content'
              ? 'DEFAULT'
              : element.cedpNo,
          updateType: 'DELETE',
        };
        deleteEDPAssociationList.push(formatData);
      }
    });
    if (deleteEDPAssociationList.length > 0) {
      this.updateEDPARAssociationAPI(
        deleteEDPAssociationList,
        this.messageList[2],
      );
    }
  }

  updateEDPData(updateList: any) {
    let updateEDPAssociationList: any = [];
    this.edp_ar_list.forEach((element: any) => {
      if (updateList.indexOf(element.cedpNo) !== -1) {
        let formatData = {
          seqNo: this.seqId,
          siteId: 204,
          edpNo:
            element.cedpNo == 'Default Site Content'
              ? 'DEFAULT'
              : element.cedpNo,
          validFrom: element.tvalidFrom,
          validTo: element.tvalidTo,
          createUserId: this.authService.username,
          oldSeqNo: null,
          oldSiteId: null,
          oldEdpNo: null,
          updateType: 'UPDATE',
        };
        updateEDPAssociationList.push(formatData);
      }
    });
    if (updateEDPAssociationList.length > 0) {
      this.updateEDPARAssociationAPI(
        updateEDPAssociationList,
        this.messageList[1],
      );
    }
  }

  deleteProgramList(data: any) {
    this.prepareProgramListDeleteData([data.uniquePrgId]);
  }

  prepareProgramListDeleteData(deleteList: any) {
    let deleteProgramList: any = [];
    this.program_list.forEach((element: any) => {
      if (deleteList.indexOf(element.uniquePrgId) !== -1) {
        let formatData = {
          seqno: element.seqno,
          siteId: element.siteId,
          programCode: element.programCode,
          workgroupId: element.workgroupId,
          updateType: 'DELETE',
        };
        deleteProgramList.push(formatData);
      }
    });
    if (deleteProgramList.length > 0) {
      this.updateProgramAssociationAPI(deleteProgramList, this.messageList[5]);
    }
  }

  updateProgramListData(updateList: any) {
    let updateProgramList: any = [];
    this.program_list.forEach((element: any) => {
      if (updateList.indexOf(element.uniquePrgId) !== -1) {
        let formatData = {
          seqno: this.seqId,
          siteId: element.siteId,
          programCode: element.programCode,
          workgroupId: element.workgroupId,
          validFrom: element.validFrom,
          validTo: element.validTo,
          createUserId: this.authService.username,
          updateType: 'UPDATE',
        };
        updateProgramList.push(formatData);
      }
    });
    if (updateProgramList.length > 0) {
      this.updateProgramAssociationAPI(updateProgramList, this.messageList[4]);
    }
  }

  selectedRows(selectedIds: any) {
    this.selectedIds = selectedIds;
  }

  getAdpErAssociation(seqId: string) {
    this.apiService.getAssociatedEdpArList(seqId).subscribe((response) => {
      if (response) {
        this.DefaultExists = false;
        response = response instanceof Array ? response : [];
        this.org_edp_ar_list = [];
        this.edp_ar_list = response.map((node: any) => {
          if (node.cedpNo == 'DEFAULT') {
            this.DefaultExists = true;
          }
          node.cedpNo =
            node.cedpNo == 'DEFAULT' ? 'Default Site Content' : node.cedpNo;
          return node;
        });
        this.org_edp_ar_list = JSON.parse(JSON.stringify(this.edp_ar_list));
        this.addDefaultToArrayList();
      }
    });
  }

  updateAssociation() {
    if (this.edpArValue.length == 0) {
      this.validateValues = true;
      return;
    }
    this.validateValues = false;
    this.newEDPAssociations = [];
    this.edpArValue.forEach((element: any) => {
      let formatData = {
        seqNo: this.seqId,
        siteId: 204,
        edpNo: element == 'Default Site Content' ? 'DEFAULT' : element,
        validFrom: new Date(this.startDate).toISOString().split('.')[0],
        validTo: new Date(this.endDate).toISOString().split('.')[0],
        createUserId: this.authService.username,
        oldSeqNo: null,
        oldSiteId: null,
        oldEdpNo: null,
        updateType: 'ADD',
      };
      this.newEDPAssociations.push(formatData);
    });
    this.updateEDPARAssociationAPI(
      this.newEDPAssociations,
      this.messageList[0],
    );
  }

  updateEDPARAssociationAPI(data: any, message: string) {
    this.apiService.updateAssociatedEdpArList(data).subscribe((response) => {
      if (response) {
        this.resetForm();
        this.apiService.createNotification('success', message);
        this.getAdpErAssociation(this.seqId);
      }
    });
  }

  updatePrgrmAssociation() {
    let workProgramValue = [];
    if (this.workProgramValue.find((node: any) => node == '0')) {
      workProgramValue = this.workProgramList
        .filter((res: any) => res.cWorkgroupid != 0)
        .map((res: any) => res.cWorkgroupid);
    } else {
      workProgramValue = this.workProgramValue;
    }
    if (!this.programValue || workProgramValue.length == 0) {
      this.validateValues = true;
      return;
    }
    this.validateValues = false;
    let associateArr: any = [];
    workProgramValue.forEach((node: any) => {
      associateArr.push({
        seqno: this.seqId,
        siteId: 204,
        programCode: this.programValue,
        workgroupId: node,
        validFrom: new Date(this.startDate).toISOString().split('.')[0],
        validTo: new Date(this.endDate).toISOString().split('.')[0],
        createUserId: this.authService.username,
        createTs: new Date().toISOString().split('.')[0],
        updateType: 'ADD',
      });
    });
    this.updateProgramAssociationAPI(associateArr, this.messageList[3]);
  }

  updateProgramAssociationAPI(data: any, message: string) {
    this.apiService
      .updatePrgrmAssociation(this.seqId, data)
      .subscribe((response) => {
        if (response) {
          this.apiService.createNotification('success', message);
          this.workProgramValue = [];
          this.workProgramList = [];
          this.isOthersSelected = false;
          this.isZeroSelected = false;
          this.resetForm();
          this.getPrgmAssociation();
        }
      });
  }

  getProgramList() {
    this.apiService.getProgramList().subscribe((response) => {
      if (response) {
        this.programList = response;
        this.getPrgmAssociation();
      }
    });
  }

  getWorkProgramList() {
    this.workProgramValue = [];
    this.apiService
      .getWorkProgramList(this.seqId, this.programValue)
      .subscribe((response) => {
        if (response) {
          this.workProgramList = response;
          if (response.length > 0) {
            this.workProgramList.unshift({
              cWorkgroupid: '0',
              cWorkgroupname: 'ALL',
            });
          }
        }
      });
  }

  onWorkgroupChange(selectedValues: string[]): void {
    // Fallback security check if the field gets completely cleared
    if (!selectedValues || selectedValues.length === 0) {
      this.isZeroSelected = false;
      this.isOthersSelected = false;
      return;
    }

    // 1. Strict string check to see if '0' is active
    this.isZeroSelected = selectedValues.includes('0');

    // 2. Check if any other string IDs exist in the selection array
    this.isOthersSelected = selectedValues.some((id) => id !== '0');
  }

  getPrgmAssociation() {
    this.apiService.getPrgrmAssociation(this.seqId).subscribe((response) => {
      if (response) {
        this.program_list = response;
        this.org_program_list = [];
        this.program_list =
          this.program_list instanceof Array ? this.program_list : [];
        this.program_list.map((node: any) => {
          Object.assign(node, {
            uniquePrgId:
              node.seqno +
              '_' +
              node.siteId +
              '_' +
              node.programCode +
              '_' +
              node.workgroupId,
          });
        });
        this.org_program_list = JSON.parse(JSON.stringify(this.program_list));
      }
    });
  }

  resetForm() {
    this.selectedIds = new Set<number>();
    this.setDefaultDateRange();

    if (this.activeTab == 'Linked AR/EDP') {
      this.edpArValue = [];
      this.edp_ar_list = [...this.edp_ar_list];
    } else {
      this.programValue = '';
      this.workProgramValue = [];
      this.program_list = [...this.program_list];
    }
  }

  closeSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
  }

  openEndPicker() {
    this.endDatePicker.nzDisabled = false;
  }

  searchValue(searchValue: string, searchField: any) {
    this.dataGridComponent.searchData(searchValue, searchField);
  }
}
